<template>
  <div>
    <ob-modal2 :show.sync="openModal" :type="1" :width="900" :backdrop="true">
      <div class="modal-header">
        <h4 class="modal-title"> Profile Summary</h4>
        <!-- <a href="javascript:;" @click="goToProfilePage" v-if="summaryDataDetails">Go to profile page</a> -->
      </div>
      <div class="modal-body" v-if="openModal">
        <template v-if="summaryDataDetails == null">
          <ob-spinner></ob-spinner>
        </template>
        <template v-else>
          <div class="summary-cont" id="printdocument">
            <div class="Candidate-information-info">
              <div class="header-top-section">
                CANDIDATE INFORMATION
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Full Name </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.Employee && summaryDataDetails.Employee.ConsultantName ? summaryDataDetails.Employee.ConsultantName : 'N/A'}}</div>
                <div class="col-md-3 info-label">Designation </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.Employee && summaryDataDetails.Employee.Designation ? summaryDataDetails.Employee.Designation : 'N/A'}}</div>
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Email Address </div> 
                <div class="col-md-3 info-data" style="white-space:nowrap;overflow:hidden;text-overflow: ellipsis;"><span v-tooltip.top="summaryDataDetails && summaryDataDetails.Employee && summaryDataDetails.Employee.EmailAddress ? summaryDataDetails.Employee.EmailAddress : 'N/A'">{{summaryDataDetails && summaryDataDetails.Employee && summaryDataDetails.Employee.EmailAddress ? summaryDataDetails.Employee.EmailAddress : 'N/A'}}</span></div>
                <div class="col-md-3 info-label">Phone Number</div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.Employee && summaryDataDetails.Employee.PhoneNumber ? summaryDataDetails.Employee.PhoneNumber : 'N/A'}}</div>
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Tax Term </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.Employee && summaryDataDetails.Employee.TaxTerms ? summaryDataDetails.Employee.TaxTerms : 'N/A'}}</div>
                <div class="col-md-3 info-label">Home Address </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.Employee && summaryDataDetails.Employee.HomeAddress ? summaryDataDetails.Employee.HomeAddress : 'N/A'}}</div>
              </div>
            </div>
           <div class="Candidate-information-info">
              <div class="header-top-section">
                CURRENT PROJECT INFORMATION
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Project Title </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.Project && summaryDataDetails.Project.JobName ? summaryDataDetails.Project.JobName : 'N/A'}}</div>
                <div class="col-md-3 info-label">End Client Name </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.Project && summaryDataDetails.Project.EndClientName ? summaryDataDetails.Project.EndClientName : 'N/A'}}</div>
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Start Date </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.Project && summaryDataDetails.Project.StartDate ? summaryDataDetails.Project.StartDate : 'N/A'}}</div>
                <div class="col-md-3 info-label">Duration</div>
                <div class="col-md-3 info-data" v-if="summaryDataDetails && summaryDataDetails.Project != null && summaryDataDetails.Project.Duration != 0">{{ summaryDataDetails.Project.Duration }} Months</div>
                  <div class="col-md-3 info-data"  v-else>0 Months</div>

              </div>            
            </div>
            <div class="Candidate-information-info flow-diagram-client">
            <link-flow-diagram v-if="summaryDataDetails && summaryDataDetails.ProjectLayerList && summaryDataDetails.ProjectLayerList != null" :link="summaryDataDetails.ProjectLayerList" :onTaxTermData="summaryFlowDiagram" :showEdit="false"></link-flow-diagram>
            </div>
             <!-- <div class="Candidate-information-info" v-if="isHRManager">
              <div class="header-top-section">
                CLIENT INFORMATION
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Client Org Name </div>
                <div class="col-md-3 info-data">{{NAOrValue(summaryDataDetails.Project, 'ClientName')}}</div>
                <div class="col-md-3 info-label">Client Contact Name </div>
                <div class="col-md-3 info-data">{{NAOrValue(summaryDataDetails.Project, 'ClientContactName')}}</div>
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">               
                <div class="col-md-3 info-label">Client Contact Email</div>
                <div class="col-md-3 info-data">{{NAOrValue(summaryDataDetails.Project, 'ClientEmail')}}</div>
              </div>
            </div> -->
            <div class="Candidate-information-info" v-if="summaryDataDetails && summaryDataDetails.PAFDetails != null">
              <div class="header-top-section">
                LCA INFORMATION
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Area Code </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.PAFDetails && summaryDataDetails.PAFDetails.AreaCode ? summaryDataDetails.PAFDetails.AreaCode : 'N/A'}}</div>
                <div class="col-md-3 info-label">OES/SOC Title </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.PAFDetails && summaryDataDetails.PAFDetails.SOCTitle ? summaryDataDetails.PAFDetails.SOCTitle : 'N/A'}}</div>
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">OES/SOC Code </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.PAFDetails && summaryDataDetails.PAFDetails.SOCCode ?  summaryDataDetails.PAFDetails.SOCCode : 'N/A'}} </div>
                <div class="col-md-3 info-label">Wage Offered</div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.PAFDetails && summaryDataDetails.PAFDetails.MinAnnualWage ? summaryDataDetails.PAFDetails.MinAnnualWage : ''}} <span v-if="summaryDataDetails && summaryDataDetails.PAFDetails && summaryDataDetails.PAFDetails.MaxAnnualWage">-</span>{{summaryDataDetails && summaryDataDetails.PAFDetails && summaryDataDetails.PAFDetails.MaxAnnualWage ? summaryDataDetails.PAFDetails.MaxAnnualWage : ''}}</div>
              </div>
            </div>
            <div class="Candidate-information-info" v-if="summaryDataDetails && summaryDataDetails.H1BDetails != null">
              <div class="header-top-section">
                H1B INFORMATION
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Reciept Number </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.H1BDetails && summaryDataDetails.H1BDetails.ReceiptNumber ?  summaryDataDetails.H1BDetails.ReceiptNumber : 'N/A'}}</div>
              </div>
              <div id="r1" class="row i9-auditTrial__Content clearfix">
                <div class="col-md-3 info-label">Start Date </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.H1BDetails && summaryDataDetails.H1BDetails.StartDate ? summaryDataDetails.H1BDetails.StartDate : 'N/A'}} </div>
                <div class="col-md-3 info-label">End Date </div>
                <div class="col-md-3 info-data">{{summaryDataDetails && summaryDataDetails.H1BDetails && summaryDataDetails.H1BDetails.EndDate ? summaryDataDetails.H1BDetails.EndDate : 'N/A'}} </div>
              </div>
            </div>
            <div v-if="summaryDataDetails && summaryDataDetails.FDNSReportList">
              <div class="Candidate-information-info" v-for="(fdnslist,index) in summaryDataDetails.FDNSReportList" :key="index">
                <div class="header-top-section">
                  FDNS VISIT - {{summaryDataDetails.FDNSReportList.length - index}}
                </div>
                <div id="r1" class="row i9-auditTrial__Content clearfix">
                  <div class="col-md-3 info-label">Visit Date </div>
                  <div class="col-md-3 info-data">{{fdnslist && fdnslist.VisitDate ? fdnslist.VisitDate : 'N/A'}}</div>
                  <div class="col-md-3 info-label">Visit Officer Name</div>
                  <div class="col-md-3 info-data">{{fdnslist && fdnslist.VisitOfficerName ? fdnslist.VisitOfficerName : 'N/A'}}</div>
                </div>
                <div id="r1" class="row i9-auditTrial__Content clearfix">
                  <div class="col-md-3 info-label">Visit Location </div>
                  <div class="col-md-3 info-data">{{fdnslist && fdnslist.VisitDate ? fdnslist.VisitDate: 'N/A'}}</div>
                  <div class="col-md-3 info-label">FDNS Visit Questions</div>
                  <div class="col-md-3 info-data"><a @click="isViewAuditReportPopUp(fdnslist.ReportId)">View FDNS Visit Report</a></div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="modal-footer" v-if="summaryDataDetails">
        <ob-button type="secondary" @click="openModal= false">Close</ob-button>
        <ob-button type="secondary" @click="onPrint">Print</ob-button>
      </div>
    </ob-modal2>
    <view-auditreport-popup :openviewAuditProfilePopUp.sync="toOpenviewProfileSummaryPopUp" :tosummaryReportId=summaryReportId></view-auditreport-popup>
  </div>
</template>
<script>
import utils from '@/components/Core/utils.js'
import LinkFlowDiagram from "../../ESSProjects/EmpLinkFlowDiagram.vue";
import c from '@/components/Core/constants.js'
import ViewAuditReportPopUp from "./ViewAuditReportPopup.vue";
export default {
  props: {
    openviewProfileSummaryPopUp: {
      type: Boolean,
      default: false
    },
    toSummaryIdDetails: {},
    jsOrgData: {}
  },
  data() {
    return {
      openModal: false,
      toOpenviewProfileSummaryPopUp: false,
      summaryDataDetails: null,
      spinnerSummaryDetails: false,
      summaryReportId: "",
      summaryFlowDiagram: "W2"
    };
  },
  created() {
    this.openModal = this.openviewProfileSummaryPopUp;
  },
  computed:{
      isHRManager(){
              return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.HRManager
          },
          isConsultant() {
              return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Consultant
          },
  },
  components: {
    "view-auditreport-popup": ViewAuditReportPopUp,
    "link-flow-diagram": LinkFlowDiagram
  },
  watch: {
    openviewProfileSummaryPopUp(val) {
      this.openModal = val;
    },
    openModal(val) {
      this.$emit("update:openviewProfileSummaryPopUp", val);
      if (val == true) {
        this.init();
      }
      if (val == true) {
        this.summaryDataDetails = null;
      }
    },
    summaryDataDetails(){
      // alert("ente")
      console.log("summaryDataDetails", this.summaryDataDetails)
    }
    
  },
  methods: {
    fun(){
      alert('f')
      return 'test'
    },
    NAOrValue(obj, key) {
      alert("utils")
    // retun utils.NAOrValue(obj, key);
    },
    onPrint() {
      var w = window.open();
      var printOne = document.getElementById("printdocument").innerHTML;
      w.document.write(
        '<html><head><title>Summary</title><style>* { box-sizing: border-box; } #r1::before{content:"";display:table;} #r1::after {content:""; clear:both; display:table;} .modal-body{ font-family:sans-serif;} #r1{ padding:15 15 15 15;} .col-md-12 { float: left; width: 100%; } .col-md-6 { float: left; width: 50%; } .col-md-2 { float: left; width: 16.66666667%; } .col-md-4 { float: left; width: 33.33333333%;} .col-md-3 { width:25%;float:left; word-wrap: break-word;} body { -webkit-print-color-adjust: exact; font-size: 13px; font-family: sans-serif;}.modal-header h4 {display: inline-block;}.modal-header a {float: right;font-size: 12px;font-style: italic;text-decoration: underline;color: #4a90e2;font-weight: 600;letter-spacing: 0.3px;padding-top: 3px;}.modal-body {padding: 20px 25px 35px;border: 1px solid #eee;border-radius: 4px;box-shadow: #eee 0px 0px 4px;}.modal-body thead tr {background: #eee;}.modal-body thead tr th {padding: 15px 15px;color: #333;font-size: 12px;font-weight: 500;}.modal-body .i9-auditTrial__Heading {text-decoration: underline;color: #333;padding-bottom: 5px;font-weight: 600;}.modal-body td {padding: 15px 15px;color: #333;}.modal-body .i9-summary__subContent {font-weight: 500;}.modal-body .summary-cont {border: 1px solid #efefef;}.modal-body .summary-cont .header-top-section {background: #eeeeef;padding: 10px 15px;font-size: 14px;font-weight: 500;}.modal-body .summary-cont .info-data {color: #30303f;font-size: 12px;font-weight: 500;}.modal-body .summary-cont .info-label {font-size: 12px;}.modal-body .summary-cont .i9-auditTrial__Content:nth-child(odd) {background: #fff;margin: 0;padding: 15px;}.modal-body .summary-cont .i9-auditTrial__Content:nth-child(even) {background: #f8f8f8;margin: 0;padding: 15px;}.modal-body .summary-cont .i9-auditTrial__Content a {text-decoration: underline;color: #337ab7;}.project-control-documents .col-md-3 { margin-bottom: 10px; padding-left: 0; } .project-control-documents.editing .headline-message { overflow: visible; } .project-control-documents.editing input[readonly] { background-color: #eeeeee !important; } #project_clientDetails{ overflow: auto; } #project_clientDetails .ul { margin: 0 10px; display: inline-flex; } #project_clientDetails .ul .li { width: 115px; height: 48px; position: relative; list-style-type: none; padding: 7px 10px 10px 12px; border: 2px solid #979797; border-radius:5%; float: left; margin-left: 30px; margin-bottom: 25px; } #project_clientDetails .ul .li .website_txt { font-size: 10px; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; } #project_clientDetails .ul .li .website_org { color: #143361; font-size:12px; font-weight: 600; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; } #project_clientDetails .ul .li:after { content: ""; background: #979797; position: absolute; top: 24px; width: 32px; height: 2px; margin-left: 100px; } #project_clientDetails.ul .li:last-child:after { width: 0px !important; } #project_clientDetails .ul .li:last-child .left { display: none; } #project_clientDetails .ul .li:first-child { margin-left: 0; } #project_clientDetails .ul .li i { border: solid #979797; border-width:0 2px 2px 0; display: inline-block; padding: 3px; } #project_clientDetails .ul .li .right { position: absolute; left: -11px; top: 21px; transform: rotate(-45deg); -webkit-transform: rotate(-45deg); } #project_clientDetails .ul .li .left { position: absolute;right: 0; margin-right: -11px; top: 21px; z-index: 1; transform: rotate(135deg); -webkit-transform: rotate(135deg); } #project_clientDetails .ul .Vendor-org i.left { display: none; } .edit-link-client { float: right; margin-right: 17px; font-weight: 600;font-size: 13px; font-style: italic; } .m0{margin:0 !important} #project_clientDetails .ul .li[data-v-5174aa36]:last-child:after {width: 0px !important;}.flow-diagram-client h4 { background: #eeeeef; padding: 10px 29px; font-size: 14px; font-weight: 600; text-transform: uppercase; }</style></head><body class="modal-body"><h1 style="margin: 0; padding: 15px; font-size: 20px;">Summary</h1><div class="summary-cont">' +
          printOne +
          "</div></body></html>"
      );
      w.window.print();
      w.document.close();
    },
    goToProfilePage() {
      
      if (this.summaryDataDetails) {
        let sd = this.summaryDataDetails;
        let workpermit = sd.Employee.TaxTerms.split("W2-")[1];
        let url = `${c.APPLICATIONBASEURL}/app/profile/${
          sd.Employee.ConsultantId
        }/onblick/projectsinfo?tax=W2&workpermit=${workpermit}&noprogress=true&nocallchat=true`;
        window.open(url, "_blank");
      }
    },
    isViewAuditReportPopUp(v) {
      this.toOpenviewProfileSummaryPopUp = true;
      this.openModal = false;
      this.summaryReportId = {
        ReportIdSummary: v,
        empId: this.toSummaryIdDetails
      };
    },
    init() {
      /*if (this.isHRManager) {
        ajax.get(
          `/FDNSAudit/GetSummaryDetails?consultantId=${
            this.toSummaryIdDetails
          }`,
          {},
          res => {
            if (res.data.State == true) {
              this.summaryDataDetails = res.data.FdnsModel;
              if (
                this.summaryDataDetails.Project != null &&
                this.summaryDataDetails.Project.JobId != null &&
                this.summaryDataDetails.Project.JobId != ""
              ) {
                if (this.summaryDataDetails.ProjectLayerList == null) {
                  this.generateLayerInformation(this.summaryDataDetails);
                }
              }
            } else {
              this.$message({
                type: "error",
                message: res.data.Message
              });
            }
          }
        );
      } else {*/
        ajax.get(
          `/FDNSAudit/GetSummaryDetailsForJobSeeker?empOrgId=${
            this.toSummaryIdDetails
          }`,
          {},
          res => {
            if (res.data.State == true) {
              this.summaryDataDetails = res.data.FdnsModel;

              if (
                this.summaryDataDetails.Project != null &&
                this.summaryDataDetails.Project.JobId != null &&
                this.summaryDataDetails.Project.JobId != ""
              ) {
                if (this.summaryDataDetails.ProjectLayerList == null) {
                  this.generateLayerInformation(this.summaryDataDetails);
                }
              }
            } else {
              this.ESSEnableDisable(res)
              this.$message({
                type: "error",
                message: res.data.Message
              });
            }
          }
        );
      //}
    },
    generateLayerInformation(empDetails) {
      var dataDetails;
     /* if (this.isHRManager) {
        dataDetails = [
          {
            IsEdit: true,
            OrganizationName: empDetails.Project.EndClientName,
            Type: "EndClient",
            Website: ""
          },
          {
            IsEdit: true,
            OrganizationName: empDetails.Project.ClientName,
            Type: "Client",
            Website: ""
          },
          {
            IsEdit: false,
            OrganizationName: this.loggedInUserObj.OrgName,
            Type: "Self",
            Website: this.loggedInUserObj.OrgWebSite
          }
        ];
      } else {*/
        dataDetails = [
          {
            IsEdit: true,
            OrganizationName: empDetails.Project.EndClientName,
            Type: "EndClient",
            Website: ""
          },
          {
            IsEdit: true,
            OrganizationName: empDetails.Project.ClientName,
            Type: "Client",
            Website: ""
          },
          {
            IsEdit: false,
            OrganizationName: empDetails.Employee.OrgName,
            Type: "Self",
            Website: empDetails.Employee.OrgWebSite
          }
        ];
     // }

      this.summaryDataDetails.ProjectLayerList = dataDetails;
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-header {
  h4 {
    display: inline-block;
  }
  a {
    float: right;
    font-size: 12px;
    font-style: italic;
    text-decoration: underline;
    color: #4a90e2;
    font-weight: 600;
    letter-spacing: 0.3px;
    padding-top: 3px;
  }
}

.modal-body {
  padding: 20px 25px 35px;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: #eee 0px 0px 4px;
  thead {
    tr {
      background: #eee;
      th {
        /*width:50%;*/
        padding: 15px 15px;
        color: #333;
        font-size: 12px;
        font-weight: 600;
      }
    }
  }
  .i9-auditTrial__Heading {
    //background: #f8f8f8;
    text-decoration: underline;
    color: #333;
    padding-bottom: 5px;
    font-weight: 600;
  }
  td {
    padding: 15px 15px;
    color: #333;
  }
  .i9-summary__subContent {
    font-weight: 600;
  }
  .summary-cont {
    border: 1px solid #efefef;
    .header-top-section {
      background: #eeeeef;
      padding: 10px 29px;
      font-size: 14px;
      font-weight: 600;
    }
    .info-data {
      color: #30303f;
      font-size: 12px;
      font-weight: 600;
    }
    .info-label {
      font-size: 12px;
    }
    .i9-auditTrial__Content {
      &:nth-child(odd) {
        background: #fff;
        margin: 0;
        padding: 15px;
      }
      &:nth-child(even) {
        background: #f8f8f8;
        margin: 0;
        padding: 15px;
      }
      a {
        text-decoration: underline;
        color: #337ab7;
      }
    }
  }
}
</style>
<style lang="scss">
.flow-diagram-client {
  h4 {
    background: #eeeeef;
    padding: 10px 29px;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
  }
}
</style>
<style lang="scss">
.flow-diagram-client {
  .ul {
    padding-left: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/FDNS/FDNS-PopUp/ViewProfileSummaryPopup.vue